import React, { useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import { BsFillCaretDownFill, BsFillCaretUpFill } from "react-icons/bs";
import { secondsToHHMM } from "../../../Utilitie";

const NKJYardExMonthWise = ({ data, selectedFy }) => {
  const tableRef = useRef();
  const key = [
    "CC",
    "PREMIUM",
    "Intensive",
    "Total Rakes",
    "Total Exam Time",
    "Avg. Exam Time",
    "MR Sick (inc B.Van)",
    "ROH",
    "POH (inc B.Van)",
    "NPOH",
    "Gap or Position Change",
    "Inter Mix",
    "BMBS (Knorr / Escorts / Conven.)",
    "Total",
    "Avg. Shunt Per rake",
    "Avg. Release to Departure",
    "Avg. Arrival to Departure",
  ];

  const monthOrder = [
    "Apr",
    "May",
    "Jun",
    "July",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];
  if (!Array.isArray(data) || data.length === 0) {
    return <p>No data available</p>;
  }

  const mergedData = {};

  data.forEach((yearData) => {
    yearData.children?.forEach((monthEntry) => {
      const month = monthEntry.MONTH;

      if (!mergedData[month]) {
        mergedData[month] = {};
      }
      mergedData[month][yearData.F_YEAR] = monthEntry.data[0];
    });
  });

  const fyYears = data.map((d) => d.F_YEAR);

  return (
    <div>
      <h6 className="p-3 bg-dark text-white">
        NKJ YARD EXAMINATION MONTH WISE SUMMARY
      </h6>{" "}
      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-striped table-bordered "
          style={{ fontSize: "13px" }}
        >
          <thead>
            <tr className="table-dark text-center">
              <th></th>
              {fyYears.map((fy) => (
                <>
                  <th colSpan={17}>({fy})</th>
                </>
              ))}
            </tr>
            <tr
              className="table-dark text-center"
              style={{ fontWeight: "bold" }}
            >
              <th></th>
              {fyYears.map((fy) => (
                <>
                  <th colSpan={6}>Examination Type </th>
                  <th colSpan={9}>Sick marking </th>
                  <th colSpan={2}>Detention </th>
                </>
              ))}
            </tr>

            <tr
              className="table-dark text-center"
              style={{ fontWeight: "bold" }}
            >
              <th>Month</th>
              {fyYears.map((fy) =>
                key.map((h, i) => (
                  <th key={`${fy}-${i}`} className="text-wrap align-middle">
                    {h}
                  </th>
                )),
              )}
            </tr>
          </thead>

          <tbody>
            {monthOrder
              .filter((month) => mergedData[month])
              .map((month) => (
                <tr key={month} className="text-center">
                  <td>{month}</td>

                  {fyYears.map((fy) => {
                    const fyData = mergedData[month][fy] || {};

                    return (
                      <React.Fragment>
                        <td>{fyData["EX_TY_CC"] || "_"}</td>
                        <td>{fyData["EX_TY_PREMIUM"] || "_"}</td>
                        <td>{fyData["EX_TY_INTENSIVE"] || "_"}</td>
                        <td>{fyData["TOTAL_RAKES"] || "_"}</td>
                        <td>
                          {secondsToHHMM(fyData["TOTAL_EXAM_TIME"]) || "_"}
                        </td>
                        <td>{secondsToHHMM(fyData["AVG_EXAM_TIME"]) || "_"}</td>
                        <td>{fyData["SM_MR_Sick_inc_B_Van"] || "_"}</td>
                        <td>{fyData["SM_ROH"] || "_"}</td>
                        <td>{fyData["SM_POH_inc_B_Van"] || "_"}</td>
                        <td>{fyData["SM_NPOH"] || "_"}</td>
                        <td>{fyData["SM_Gap_or_Position_Change"] || "_"}</td>
                        <td>{fyData["SICK_MR_SER_INTER_MIX"] || "_"}</td>
                        <td>{fyData["SICK_MR_SER_BMBS"] || "_"}</td>
                        <td>
                          {fyData["SM_MR_Sick_inc_B_Van"] +
                            fyData["SM_ROH"] +
                            fyData["SM_POH_inc_B_Van"] +
                            fyData["SM_NPOH"] +
                            fyData["SM_Gap_or_Position_Change"] +
                            fyData["SICK_MR_SER_INTER_MIX"] +
                            fyData["SICK_MR_SER_BMBS"] || "_"}
                        </td>
                        <td>
                          {fyData["SICK_MR_SER_Avg_Shunt_per_Rake"] || "_"}
                        </td>
                        <td>
                          {secondsToHHMM(
                            fyData["Det_Avg_Release_to_Departure"],
                          ) || "_"}
                        </td>
                        <td>
                          {secondsToHHMM(
                            fyData["Det_Avg_Arrival_to_Departure"],
                          ) || "_"}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`NKJ Yard  Month wise data  -${selectedFy} }`}
      />
    </div>
  );
};

export default NKJYardExMonthWise;
